import React from 'react';
import utils from 'utils';
import MODAL, { MODAL_THEMES, MODAL_BUTTON_TYPES } from 'constants/modals';
import Modal from 'components/Modal';
import { ModalFooter } from 'components/Modal/ModalFooter';

const { ACCEPT } = MODAL_BUTTON_TYPES;

/**
 * AlreadySkippingTheCounterHelpModal
 * @return {JSX}
 */
const AlreadySkippingTheCounterHelpModal = () => (
  <Modal
    modalKey={MODAL.ALREADY_SKIPPING_THE_COUNTER_HELP_MODAL}
    theme={MODAL_THEMES.WHITE}
    header={utils.i18n('already_skipping_the_counter_help_title')}
  >
    <>
      <p
        id={`${MODAL.ALREADY_SKIPPING_THE_COUNTER_HELP_MODAL}_desc`}
        className='modal-themed__paragraph modal-themed__paragraph--center-align'
      >
        {utils.i18n('already_skipping_the_counter_help_copy')}
      </p>

      <ModalFooter
        buttons={[
          {
            type: ACCEPT,
            label: utils.i18n('common_close'),
          },
        ]}
      />
    </>
  </Modal>
);

export default AlreadySkippingTheCounterHelpModal;
